import { useState, useEffect } from "react";
import { useReducedMotion } from "framer-motion";

/**
 * Returns `isMobile` (< 768px) and `shouldReduceMotion`
 * (prefers-reduced-motion OR mobile).
 * Use to throttle or disable expensive animations on mobile.
 */
export function usePerformance() {
  const prefersReducedMotion = useReducedMotion();
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 768
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", check, { passive: true });
    return () => window.removeEventListener("resize", check);
  }, []);

  return {
    isMobile,
    shouldReduceMotion: !!(prefersReducedMotion || isMobile),
  };
}
